import styled from 'styled-components'
import { Row } from 'react-bootstrap'

export const RowActions = styled(Row)`
  svg {
    cursor: pointer;
  }
`
